import { useEffect } from 'react'

import PropTypes from 'prop-types'

import { FetchHelper } from '../../helpers/fetch'

import { useSimpleState } from '../useSimpleState'

const useControlSearchCategories = (props={}) => {
    const {_state: _results} = useSimpleState()

    const fetch = () => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/categories'
        })
            .then((res) => {
                if (res.status === 200) {
                    _results.set(res)
                }
            })
            .catch((res) => {
                console.log('control search categories fetch error', res)
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    // /categories is the public, delete_date-filtered list — a single
    // category being edited still needs the dedicated GET route so a
    // soft-deleted one (not in that list) can still be opened
    const fetchGetCategory = (id) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: `/api/v1/categories/${id}`
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const fetchCreate = (body) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/categories/post',
            options: {
                method: 'post',
                data: body
            }
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const fetchEdit = (body) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/categories/update',
            options: {
                method: 'put',
                data: body
            }
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const fetchDelete = (item) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/categories/delete',
            options: {
                method: 'put',
                data: {
                    id: item.id
                }
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    fetch()
                }

                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    useEffect(() => {
        fetch()
    }, [])

    return Object.freeze({
        _results,
        _control: {
            fetch,
            fetchGetCategory,
            fetchCreate,
            fetchEdit,
            fetchDelete
        }
    })
}

useControlSearchCategories.propTypes = {
    beforeFetch: PropTypes.func,
    afterFetch: PropTypes.func,
}

export { useControlSearchCategories }
